module.exports = __webpack_public_path__ + "img/Large-Fridge.dc065585.png";